<template>
    <v-card>
        <v-card-text>
            <v-row v-if="serviceDetails.length == 0">
                <v-col class="text-center">ไม่ข้อมูล Update งานช่าง</v-col>
            </v-row>
            <v-row
              v-for="serviceDetail in serviceDetails"
              :key="serviceDetail.value"
            >
                <v-col align-self="center" cols="2" class="text-center justify-center">
                  <strong>{{ serviceDetail.name }} </strong></v-col
                >
                <v-col>
                    <vue-dropzone
                      :ref="'dropzone_' + serviceDetail.value"
                      :id="serviceDetail.value"
                      :options="dropzoneOptions"
                      :include-styling="true"
                      @vdropzone-removed-file="removeImage"
                      @vdropzone-thumbnail="addedImage"
                      @vdropzone-mounted="loadImage(serviceDetail.value)"
                    >
                    </vue-dropzone>
                </v-col>
            </v-row>
            <div>
                <v-dialog v-model="showImage" fullscreen
                hide-overlay
      transition="dialog-bottom-transition">
                  <ImagePreview ref='imagePreview' @close="showImage = false"></ImagePreview>
                </v-dialog>
            </div>
        </v-card-text>
        <v-card-actions v-if="canDownloadReport">
          <v-btn
            class="ma-2"
            color="primary"
            small
            target="_blank"
            @click="downloadReport"
            ><v-icon>mdi-floppy</v-icon> รายงานภาพงานซ่อม</v-btn
          >
        </v-card-actions>
    </v-card>
</template>

<style >
    .dropzone .dz-preview .dz-zoom {
      font-size: 14px;
      text-align: center;
      display: block;
      cursor: pointer;
      border: none;
      float: right;
      margin-right: 10px;
    }
    .dropzone .dz-preview .dz-zoom:hover {
      text-decoration: underline;
    }
    .vue-dropzone > .dz-preview .dz-zoom {
      position: absolute;
      z-index: 30;
      color: #fff;
      margin-left: 85px;
      padding: 10px;
      top: inherit;
      bottom: 15px;
      border: 2px #fff solid;
      text-decoration: none;
      text-transform: uppercase;
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 1.1px;
      opacity: 0;
    }
    .vue-dropzone > .dz-preview:hover .dz-zoom {
      opacity: 1;
    }
</style>

<script>
import vue2Dropzone from "vue2-dropzone";
import { exportJobImage } from "@/api/reports/report-api.js";
import ImagePreview from '@/components/Shared/ImagePreview';

export default {
  name: "Tab6",
  components: {
    vueDropzone: vue2Dropzone,
    ImagePreview
  },
  watch: {
    jobServiceDetails() {
      this.getDetailItem();
    },
  },
  props: ["jobServiceDetails", "jobImages", "canEdit", "branchCode", "jobNo", "serviceDetails"],
  data: (v) => ({
    showImage: false,
    imageContent: '',
    dropzoneOptions: {
      url: "https://sk-auto.ddns.net/bpc",
      thumbnailWidth: 200,
      maxFilesize: 3,
      autoProcessQueue: false,
      addRemoveLinks: true,
      autoQueue: true,
      duplicateCheck: true,
      clickable: v.canEdit,
    },
    images: [],
    oldImages: [
      {
        code: "",
        item: [],
      },
    ],
    canDownloadReport: false,
  }),
  methods: {
    createPreviewIcon(key, serviceDetailCode) {
        let _this = this;
        let nodeA = document.createElement("a");
        nodeA.setAttribute("class", "dz-zoom");
        nodeA.setAttribute("target", "_blank");
        let name = this.serviceDetails.filter(o => o.value == serviceDetailCode)[0].name;
        nodeA.onclick = function() {
            _this.showImage = true;
            _this.$nextTick(() => {
                _this.$refs.imagePreview.setContent(key, 
                _this.$refs["dropzone_" + serviceDetailCode][0].dropzone.files,
                name
                );
            });
        }
        nodeA.innerHTML = '<span class="material-icons" >zoom_in</span>';
        return nodeA;
    },
    addedImage(file) {
        let key = file.dataURL ? file.upload.uuid : file.imageKey;
        let dzRemove = file.previewTemplate.querySelector(".dz-remove");
        dzRemove.innerHTML = '<span class="material-icons" >delete</span>';
        let previewIcon = this.createPreviewIcon(
          key,
          file.previewElement.parentElement.id
        );
        file.previewTemplate.appendChild(previewIcon);
    },
    getDetailItem() {
      let items = [];
      this.jobServiceDetails.forEach((element) => {
        if (items.filter((e) => e.serviceDetailCode == element.value).length > 0) {
            return;
        }
        items.push(element);
      });
      return items;
    },
    removeImage(file) {
      if (!file.imageId) return;
      let filter = this.oldImages.filter(
        (o) => o.code == file.serviceDetailCode
      );

      if (!filter || filter.length <= 0) return;

      let lane = filter[0];
      let currImage = lane.items.filter((e) => e.imageId == file.imageId);

      if (!currImage || currImage.length <= 0) return;
      const index = lane.items.indexOf(currImage[0]);
      lane.items.splice(index, 1);
    },
    getImages() {
      let _this = this;
      this.serviceDetails.forEach((element) => {
        let image = {
          jobServiceDetailCode: element.value,
          imageDetails: [],
        };

        _this.$refs["dropzone_" + element.value][0].dropzone.files.forEach(file => {
              image.imageDetails.push({
                imageId: file.imageId,
              name: file.name,
              imageSize: file.size,
              content: file.dataURL,
            })
        });
        /*
        if (this.oldImages.filter((e) => e.code == element.serviceDetailCode).length > 0) {
          let tmps = this.oldImages.filter(
            (e) => e.code == element.serviceDetailCode
          );
          tmps[0].items.forEach((element) => {
            image.imageDetails.push(element);
          });
        }
        _this.$refs["dropzone_" + element.serviceDetailCode][0]
          .getQueuedFiles().forEach((file) => {
            image.imageDetails.push({
              name: file.name,
              imageSize: file.size,
              content: file.dataURL,
            });
          });
          */
        this.images.push(image);
      });
      return this.images;
    },
    loadImage(serviceDetailCode) {
      if (!this.jobImages) return;
      let _this = this;
      let elements = this.jobImages.filter(
        (o) => o.jobServiceDetailCode == serviceDetailCode
      );
      if (elements == undefined || elements.length <= 0) return;
      let element = elements[0];
     
      let oldImage = {
        code: serviceDetailCode,
        items: [],
      };
      setTimeout(() => {
        element.imageDetails.forEach((detail) => {
          _this.canDownloadReport = true;
          let item = {
            serviceDetailCode: serviceDetailCode,
            imageKey: detail.imageUrl,
            imageId: detail.imageId,
            name: detail.name,
            size: 150,
            type: "image/jpg",
          };
          oldImage.items.push(item);
          let imageUrl =
            process.env.VUE_APP_SERVICE_ROOT +
            "/common/image/" +
            detail.imageUrl;
          let thumbnailUrl =
            process.env.VUE_APP_SERVICE_ROOT +
            "/common/thumb/" +
            detail.imageUrl;

          _this.$refs["dropzone_" + element.jobServiceDetailCode][0].manuallyAddFile(item, imageUrl);

          _this.$refs["dropzone_" + element.jobServiceDetailCode][0].dropzone.emit("thumbnail", item, thumbnailUrl);
          _this.$refs["dropzone_" + element.jobServiceDetailCode][0].dropzone.emit("complete", item);

          this.customIcon(item, detail.imageUrl, serviceDetailCode);
        });
        this.oldImages.push(oldImage);
      }, 500);
    },
    downloadReport() {
      this.$loading(true);
      exportJobImage(this.branchCode, this.jobNo).then(() => {
        this.$loading(false);
      }).catch(() => {
        this.$loading(false);
      });
    },
    customIcon(item, imageUrl, serviceDetailCode) {
      let dzRemove = item.previewTemplate.querySelector(".dz-remove");
      dzRemove.innerHTML = '<span class="material-icons" >delete</span>';
      let previewIcon = this.createPreviewIcon(imageUrl, serviceDetailCode);
      item.previewTemplate.appendChild(previewIcon);
    },
  },
  mounted() {
    //this.serviceDetails = this.getDetailItem();
  },
};
 
</script>

